import { useAppSelector } from "app/hooks"
import { FlexBox } from "components/Common/FlexBox"
import CloseIcon from "components/Icons/CloseIcon"
import {
  useBackToHome,
  useProcessImage,
  useUploadImage,
} from "features/meal/hooks"
import { useDailyScanProgress } from "features/meal/hooks/scanMealHooks"
import { Fragment } from "react"
import Scanning from "./Scanning"
import TakePhoto from "./TakePhoto"
import Preview from "./Preview"
import { createImageChangeHandler } from "utils/imageConverter"

const Header = ({
  loading,
  onClose,
}: {
  loading: boolean
  onClose: () => void
}) => {
  return (
    <FlexBox
      style={{ height: 44, padding: "9px 19px", background: "#fff" }}
      $alignItems="center"
    >
      <CloseIcon
        onClick={() => {
          if (!loading) {
            onClose()
          }
        }}
        style={{
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.5 : 1,
        }}
      />
    </FlexBox>
  )
}

const BeforeScanning = () => {
  const backToHome = useBackToHome()

  const { onUploadImage } = useUploadImage()
  const { handleProcessImage } = useProcessImage()

  const onImageChange = createImageChangeHandler({
    onProcessImage: handleProcessImage,
    onUploadImage,
  })


  const step = useAppSelector((state) => state.meal.step)
  const imageBase64Encoded = useAppSelector(
    (state) => state.meal.imageBase64Encoded,
  )

  const scanningImageUrl = useAppSelector(
    (state) => state.meal.scanningImageUrl,
  )

  const { isScanDisabled, isNoRemainingScan } = useDailyScanProgress(step)
  const { processImageLoading, imageUrl, displayImageType } = useProcessImage()

  const scanMealLoading = useAppSelector((state) => state.meal.scanMealLoading)

  const hasBase64PreviewImage =
    !scanMealLoading && displayImageType === "base64" && !!imageBase64Encoded

  const hasUrlPreviewImage =
    !scanMealLoading && displayImageType === "url" && !!imageUrl

  const previewImageUrl = hasBase64PreviewImage
    ? imageBase64Encoded
    : hasUrlPreviewImage
    ? imageUrl
    : undefined

  if (step === "take-photo") {
    return (
      <TakePhoto
        onImageChange={onImageChange}
        isNoRemainingScan={isNoRemainingScan}
      />
    )
  }

  return (
    <Fragment>
      <Header
        loading={scanMealLoading || processImageLoading}
        onClose={backToHome}
      />
      {step === "preview-image" && (
        <Preview
          previewImageUrl={previewImageUrl}
          isScanDisabled={isScanDisabled}
        />
      )}

      {step === "scan-animation" && scanningImageUrl && (
        <Scanning imageUrl={scanningImageUrl} />
      )}
    </Fragment>
  )
}

export default BeforeScanning
